module.exports = __webpack_public_path__ + "img/banking-open-api-bg.80ba936b.svg";